import React from 'react'

export const PlatformSection = () => {
  return (
    <section id="platform" className="about">
      <div className="container">
        <div className="row content">
          <div className="col-lg-6">
            <img src="/assets/img/hauler-next/mobile-mockup.png" alt="Total Milk Hauler Next driver mobile app" className="img-fluid" />
            <h3 className="mt-4">Driver Mobile App</h3>
            <p>
              Built for drivers on the road. Enter pickup and delivery tickets fully offline, scan producer barcodes, and let AI
              capture pickups from a spoken note or a photographed paper manifest. Drivers sign off with Face ID, then sync every
              change to the office with one tap.
            </p>
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0">
            <img src="/assets/img/hauler-next/web-tickets.png" alt="Total Milk Hauler Next back-office web app" className="img-fluid" />
            <h3 className="mt-4">Back-Office Web App</h3>
            <p>
              The command center for your hauling operation. Track hauled weights and ticket activity on a live dashboard, manage
              tickets, customers, drivers, and mapped routes, get alerted before a driver license expires, and push finished
              tickets straight to payroll — all from any browser.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
